var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import styles from './HomePage.module.scss';
import Avatar from "../Avatar/Avatar";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { channelAPI, messagesAPI } from "../../API/api";
import classNames from "classnames";
import { convertBackChannelToClient, createObjectChannel } from "../../utils/utils";
import { doc, onSnapshot } from "firebase/firestore";
import { updateSelectedChannel } from "../../store/slices/appSlice";
import { db } from "../../firebase";
import ShowNameChat from "./ShowNameChat";
import DialogComponent, { ConfirmComponent, NotFoundChat } from "../Settings/DialogComponent";
import { outChat, setChat } from "../../store/slices/setChatIDSlice";
import { useChannelClickHandler } from "../../hooks/useHandleClickToChannel";
import { PreviewLastMessage } from "./ChatInfo";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { firebasePath } from "../../constants/constants";
const Skeleton = () => {
    return (_jsxs("li", { className: classNames(styles.chatInfo, styles.skeleton), children: [_jsx("div", { className: styles.skeleton__Avatar }), _jsx("div", { className: styles.skeleton__Name })] }));
};
const ChannelInfo = (channel) => {
    var _a;
    const [updateChannel, setUpdateChannel] = useState(Object.assign({}, channel.channel));
    const [notFoundChannel, setNotFoundChannel] = useState(false);
    const [fetchingCurrentInfo, setFetchingCurrentInfo] = useState(true);
    const [isNotAccess, setIsNotAccess] = useState(false);
    const selectedChat = useAppSelector(state => state.app.selectedChat);
    const currentUser = useAppSelector(state => state.app.currentUser);
    const { t } = useTypedTranslation();
    const dispatch = useAppDispatch();
    const isSelected = ((_a = selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.channel) === null || _a === void 0 ? void 0 : _a.channelID) === updateChannel.channelID;
    const { handleClickToChannel } = useChannelClickHandler({ isSelected, channel: updateChannel, currentUserID: currentUser.uid, setIsNotAccess, setNotFoundChannel });
    const unsubscribe = () => {
        messagesAPI.deleteChat(currentUser, createObjectChannel(channel.channel))
            .catch((err) => console.log('Произошла ошибка', err))
            .finally(() => {
            dispatch(setChat(null));
            setNotFoundChannel(false);
        });
    };
    const sendRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        yield channelAPI.applyForMembership(currentUser, updateChannel.channelID);
        setIsNotAccess(false);
    });
    useEffect(() => {
        let listenerChannelInfo = onSnapshot(doc(db, firebasePath.CHANNELS_INFO, channel.channel.channelID), (doc) => __awaiter(void 0, void 0, void 0, function* () {
            if (doc.data()) {
                const currentInfoChannel = convertBackChannelToClient(doc.data());
                const isSubscriber = currentInfoChannel.listOfSubscribers.some(item => item.uid === currentUser.uid);
                if (!isSubscriber && !currentInfoChannel.isOpen && isSelected) {
                    dispatch(outChat());
                    return;
                }
                if (isSubscriber && currentInfoChannel.dateOfChange !== channel.dateOfChange) {
                    const toChat = createObjectChannel(currentInfoChannel);
                    yield channelAPI.updateChannelInMyChatList(currentUser.email, toChat);
                }
                if (isSelected)
                    dispatch(updateSelectedChannel(Object.assign(Object.assign({}, currentInfoChannel), { owner: updateChannel.owner })));
                setUpdateChannel(currentInfoChannel);
            }
            if (fetchingCurrentInfo)
                setFetchingCurrentInfo(false);
        }));
        return () => listenerChannelInfo();
    }, [isSelected, channel]);
    if (fetchingCurrentInfo)
        return _jsx(Skeleton, {});
    if (isNotAccess)
        return (_jsx(DialogComponent, { onClose: setIsNotAccess, isOpen: isNotAccess, children: _jsx(ConfirmComponent, { confirmFunc: sendRequest, handleClose: () => setIsNotAccess(false), text: t('closedCommunityMessage') }) }));
    if (notFoundChannel)
        return (_jsx(DialogComponent, { isOpen: notFoundChannel, onClose: unsubscribe, children: _jsx(NotFoundChat, { confirmFunc: unsubscribe }) }));
    return (_jsxs("li", { className: styles.chatInfo, onClick: handleClickToChannel, children: [isSelected &&
                _jsx("div", { className: styles.selected }), _jsx(Avatar, { url: updateChannel === null || updateChannel === void 0 ? void 0 : updateChannel.photoURL, name: updateChannel.displayName[0] }), _jsxs("div", { className: styles.nameBlock, children: [_jsx("div", { className: styles.name, children: _jsx("span", { className: styles.name, children: isSelected ? _jsx(ShowNameChat, {}) : updateChannel.displayName }) }), _jsx(PreviewLastMessage, { message: updateChannel === null || updateChannel === void 0 ? void 0 : updateChannel.lastMessage, currentUserId: currentUser.uid })] })] }));
};
function checkProps(prevProps, nextProps) {
    return prevProps.displayName === nextProps.displayName && prevProps.photoURL === nextProps.photoURL;
}
export default memo(ChannelInfo, checkProps);
